import BaseApi from "@api/base.api";
import Http from "@services/http.js";

export default class NotificationsApi extends BaseApi {
    static get entity() {
        return "notifications";
    }

    static getUserNotification(params = {}) {
        return Http.get(this.entity+`/user-notifications`, params);
    }
    static getUserAllNotification(params = {}) {
        return Http.get(this.entity+`/user-all-notifications`, params);
    }

    static markAsRead(params = {}) {
        return Http.post(this.entity+`/mark-as-read`, params);
    }
    static markAsSeen(params = {}) {
        return Http.post(this.entity+`/mark-as-seen`, params);
    }
}
